module.exports = __webpack_public_path__ + "img/placeholder.59724da2.png";